var SaveVideoProgressDto = /** @class */ (function () {
    function SaveVideoProgressDto(_a) {
        var progress = _a.progress, status = _a.status, step = _a.step;
        this.progress = progress;
        this.status = status;
        this.step = step;
    }
    SaveVideoProgressDto.fromSavingVideoProgressPayload = function (_a) {
        var progress = _a.progress, status = _a.status, step = _a.step;
        return new SaveVideoProgressDto({
            progress: progress / 100,
            status: status,
            step: step,
        });
    };
    return SaveVideoProgressDto;
}());
export { SaveVideoProgressDto };
//# sourceMappingURL=SaveVideoProgressDto.js.map